import { PricingCard } from "@vb-django/components/minskog/aragon/components/templates/ProductPageNew";

// Added default values to avoid having error in the old implementation of the component.
const DEFAULT_BAS_FEATURES = [
  {
    text: "Sälja virke & biobränsle",
    details:
      "Tillgång till Treebulas marknadsplats för slutavverkning och gallring. Konkurrensutsätt ditt virke och få bästa möjliga pris.",
  },
  {
    text: "Begränsad digital skogsbruksplan",
    details:
      "Du får en bra överblick över fastigheten med utvald information per avdelning.",
  },
  {
    text: "Enkel kolkrediter översikt",
    details:
      "Möjlighet att tjäna pengar på kolkrediter från din skog. Vi visar om du har potential.",
  },
  {
    text: "Marknadsinformation",
    details:
      "Genom Treebulas unika och oberoende roll på marknaden ger vi dig uppdaterad information för bättre affärer.",
  },
];

// Added default values to avoid having error in the old implementation of the component.
const DEFAULT_PLUS_FEATURES = [
  {
    text: "Fastighetesvärdering",
    details:
      "Löpande värdering av din skogsfastighet baserad på virkesförråd och aktuella marknadspriser.",
  },
  {
    text: "Digital skogsbruksplan",
    details:
      "Få en tydlig överblick över hela din fastighet med uppdaterad fakta, kartor samt ekonomisk potential.",
  },
  {
    text: "Virkespriser",
    details: "Full tillgång till Treebulas unika prisdatabas för virkespriser",
  },
  {
    text: "Sälja virke och biobränsle",
    details:
      "Tillgång till Treebulas marknadsplats för slutavverkning och gallring. Konkurrensutsätt ditt virke och få bästa möjliga pris.",
  },
  {
    text: "Skogsövervakning och risker",
    details:
      "Din skog alltid under uppsikt med Treebulas stallitövervakning av din skog. Skador och risker tydligt presenterat.",
  },
  {
    text: "Marknadsinformation",
    details:
      "Genom Treebulas unika och oberoende roll på marknaden ger vi dig uppdaterad information för bättre affärer.",
  },
  {
    text: "Kolkrediter est. värde",
    details:
      "Se om din skog har potential för kolkrediter, det estimerade värdet och kom igång enkelt med att tjänat kolkrediter.",
  },
];

const SubscriptionCards = ({
  basTitle = "Bas",
  basFeaturesSubtitle = "Detta ingår kostnadsfritt",
  basFeatures = DEFAULT_BAS_FEATURES,
  plusTitle = "Treebula Plus",
  plusFeaturesSubtitle = "Detta ingår i Treebula Plus",
  plusFeatures = DEFAULT_PLUS_FEATURES,
  plusButtonText = "Uppgradera till Plus",
}) => {
  const basFeaturesProp = {
    subtitle: basFeaturesSubtitle,
    info: basFeatures,
  };

  const plusFeaturesProp = {
    subtitle: plusFeaturesSubtitle,
    info: plusFeatures,
  };

  return (
    <>
      <section className="w-full py-5 bg-white container">
        <div className="grid grid-cols-1 gap-6 py-8 lg:grid-cols-[repeat(2,max-content)] lg:auto-rows-fr lg:justify-center">
          <PricingCard title={basTitle} features={basFeaturesProp} />
          <PricingCard
            title={plusTitle}
            priceCardButton={{
              state: true,
              text: plusButtonText,
            }}
            features={plusFeaturesProp}
            backgroundColor="black"
          />
        </div>
      </section>
    </>
  );
};

SubscriptionCards.defaultProps = {
  basTitle: "Bas",
  basFeaturesSubtitle: "Detta ingår kostnadsfritt",
  basFeatures: DEFAULT_BAS_FEATURES,
  plusTitle: "Treebula Plus",
  plusFeaturesSubtitle: "Detta ingår i Treebula Plus",
  plusFeatures: DEFAULT_PLUS_FEATURES,
  plusButtonText: "Uppgradera till Plus",
};

SubscriptionCards.fields = {
  basTitle: {
    type: "text",
    label: "Bas - Title",
  },
  basFeaturesSubtitle: {
    type: "text",
    label: "Bas - Features Subtitle",
  },
  basFeatures: {
    type: "array",
    label: "Bas - Features",
    arrayFields: {
      text: { type: "text", label: "Text" },
      details: { type: "textarea", label: "Details (tooltip)" },
    },
  },
  plusTitle: {
    type: "text",
    label: "Plus - Title",
  },
  plusFeaturesSubtitle: {
    type: "text",
    label: "Plus - Features Subtitle",
  },
  plusFeatures: {
    type: "array",
    label: "Plus - Features",
    arrayFields: {
      text: { type: "text", label: "Text" },
      details: { type: "textarea", label: "Details (tooltip)" },
    },
  },
  plusButtonText: {
    type: "text",
    label: "Plus - Button Text",
  },
};

export default SubscriptionCards;
